// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export class DevPanelFake {
  private static instance: DevPanelFake;

  domElement: HTMLElement = document.createElement('div');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  add(): any {
    return {
      onChange: () => {},
      updateDisplay: () => {},
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange(_: any): any {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addFolder(_: any): any {
    return {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      add: (_: any) => {
        return {
          onChange: () => {},
          updateDisplay: () => {},
        };
      },
    };
  }

  show(): void {}
  hide(): void {}
  destroy(): void {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getInstance(): any {
    if (!DevPanelFake.instance) {
      DevPanelFake.instance = new DevPanelFake();
    }

    return DevPanelFake.instance;
  }
}
